import { AppState } from 'store'

export const getHomeOfficeModuleState = (state: AppState) =>
  state.modules.advisory.modules.homeOffice
